import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>Why Get App Maintenance for Your Mobile <span>Application</span></h2>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                       <p>Mobile app support and maintenance services are not only necessary but a strategic imperative for app sustainability.</p>
                       <p>Regular maintenance keeps your app optimized, secure, and compatible. Proactive measures reduce downtime, contributing to sustained success.</p>
                    </Col>
                </Row>
                <Row className="h-100 buss-padd">
                <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                    <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Enhanced User Experience</h6>
                            <p>App maintenance guarantees a consistently smooth user experience, enhancing satisfaction and user retention.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Optimized Performance</h6>
                            <p>Regular maintenance fine-tunes your app's performance, ensuring it runs efficiently across diverse platforms.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Security Assurance</h6>
                            <p>Proactive bug identification and resolution through maintenance contribute to a glitch-free app, enhancing its reliability.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Bug-Free Functionality</h6>
                            <p>The convenience and personalized experience of an app can lead to strong customer loyalty.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Future-Proofing Your App</h6>
                            <p>Investing in app maintenance is an investment in the future, ensuring your app stays relevant, efficient, and aligned with industry standards.</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Androidbuss